import Store from '../store/index'
import Router from '../router/index'

//发布时设置为true
const g_isPublish = true
//title后缀
const pageTitle = "_中安检测"

export default {
    pageTitle,
}

/**
 * 全局访问接口前缀
 * @param param
 */
export function getApiDomainName() {
    let domainName = 'http://localhost:5000'
    if (g_isPublish) {
        domainName = 'http://zapi.zhongantest.cn'
    }
    return domainName
}

/**
 * 判断是否为空
 * @param param
 */
export function isNullOrUndefined(tmp) {
    if (tmp == null || tmp === '' || tmp === undefined) {
        return true
    } else {
        //处理掉字符串开始、结束处的空格
        //可能为数字
        tmp = String(tmp)
        // console.log('tmp', tmp)
        let param = tmp.replace(/^\s*|\s*$/g, '')
        if (param == null || param === '' || param === undefined) {
            return true
        }
    }
    return false
}

/**
 * 解析token
 * @param token
 * @returns {any}
 * @constructor
 */
export function ParseJwtToken(token) {
    if (isNullOrUndefined(token)) {
        return null
    }
    let tokens = token.split(".");
    let result = JSON.parse(decodeURIComponent(escape(window.atob(tokens[1].replace(/-/g, "+").replace(/_/g, "/")))));
    return result;
}

/**
 * 判断是否为手机号格式
 * @param {any} value
 */
export function isPhone(value) {
    if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        return true;
    }
    return false;
}

/**
 * 判断是否登录
 */
export function isLogin() {
    if (Store.state.user) {
        return true
    }
    return false
}

/**
 * 判断是否登录，若否，强制去登录
 */
export function noLoginToLogin() {
    if (Store.state.user) {
        return false
    }
    if (this.$route.path != '/Login') {
        routerPushMustGo()
        Router.push('/Login')
    }
    return true
}

/**
 * 判断是否登录，若否，可选择是否去登录
 */
export function noLoginAndRouter() {
    if (!Store.state.user) {
        this.$confirm('您还未登录, 是否前往登录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning '
        }).then(() => {
            routerPushMustGo()
            Router.push('/Login')
        }).catch(() => {

        })
        return true
    }
    return false
}

/**
 * 用Router.push()跳转页面，必须执行此方法
 */
export function routerPushMustGo(){
    //全局变量值调整
    Store.commit('setIndex', false)
    //隐藏悬浮目录
    Store.commit('setFloatCategory', false)
}
